import type React from "react";

export type NoCustomerRelatedFilterDimension = string;
export type NoCustomerRelatedFilterValue = string;

export const CLEAR_FILTER_TOKEN = "SelectAll";
export const FILTER_CONCATENATE_TOKEN = " + ";
export type FilterOption = {
  value: string;
  group?: string;
  displayLabel?: string;
  badge?: React.ReactNode;
  disabled?: boolean;
  count?: number;
};

export type NestedFilter = {
  displayLabel: string;
  options: FilterOption[];
};

export type OrganizationType = "FromMicrosoft" | "FromOrganization";

export type SubMenuGroup = {
  groupLabel: OrganizationType;
  nestedOptions: NestedFilter[];
  disabled?: boolean; // Optional property to disable the group
};

export type Filter = {
  key: FilterName;
  isSingleSelect?: boolean;
  options: FilterOption[];

  /**
   * whether to hide listbox items behind scrollbar
   */
  isOverflowItemsFrom10?: boolean;

  /**
   * Whether to show the filter listbox in a wide format.
   */
  width?: "normal" | "wide";

  /**
   * Combobox filters allow for typing to find an item but currently only support singleSelect.
   */
  type: "dropdown" | "combobox" | "nested";

  /**
   * Whether to options should be scrubbed before sending to telemetry pipeline.
   * Ensure you verify it gets scrubbed, do not assume it happens automatically.
   */
  isLogValuesInTelemetry?: boolean;
  /**
   * Record of values that will be sent to telemetry instead of what's in the filter.
   * To be used if the values in the filter are customer content but we still want to send telemetry
   */
  telemetryValueOverrides?: Record<string, string>;

  /**
   * Whether to hide the filter from the UI.
   */
  hidden?: boolean;

  /**
   * Whether the filter is disabled in the UI.
   */
  disabled?: boolean;

  /**
   * The label for the submenu
   */
  displayLabel?: string;
  /**
   * Whether the filter has submenus (i.e. nested dropdowns).
   */
  submenuGroups?: SubMenuGroup[];
};

export type FilterName =
  | "displayCategory"
  | "products/name"
  | "jobType"
  | "extension"
  | "createdBy"
  | "workgroup"
  | "liked"
  | "origin"
  | "metadata"
  | "role"
  | "department"
  | "industry"
  | "education";
